import React, { useContext, useMemo } from 'react';
import { context as Context } from '@gp/components/Context';
import MetricsCard3 from '@gp/pages/StudioDashboard/StudioOverall/components/MetricsCard3';
import { round, getFormatPercentPlus, formatDateStr } from '@gp/utils/common';
import { FIELDS1, FIELD_NAMES } from '@gp/utils/metricTips';
import { getValueWithUnitText } from '@gp/pages/StudioDashboard/StudioOverall/utils';

import type { IKeyMetricsMetric } from '../../types';

import DollarIcon from '@gp/assets/svg/gameInformation/dollar.svg';

const ActualBudgetCompletionCard: React.FC<IStudioOverallActualBudgetCompletionCardProps> = (props) => {
  const { title, titleTipsCfg, value, ratio, actualOfLastYear, budgetOfThisYear, completion, dataTime } = props;

  const { commonData } = useContext<IStudioOverallOverviewContext>(Context);

  const metrics = useMemo<IKeyMetricsMetric[]>(
    () => [
      {
        metricName: `${commonData?.lastYear} Actual`,
        metricValue: getValueWithUnitText(actualOfLastYear),
      },
      {
        metricName: `${commonData?.currentYear} Budget`,
        metricValue: getValueWithUnitText(budgetOfThisYear),
      },
      {
        metricName: 'Completion%',
        // @ts-ignore
        metricValue: getFormatPercentPlus(completion, 1),
      },
    ],
    [commonData?.lastYear, commonData?.currentYear, actualOfLastYear, budgetOfThisYear, completion],
  );

  return (
    <MetricsCard3
      isTitleMultipleLinesTextBubble
      multipleLinesTextFields={FIELDS1}
      multipleLinesTextFieldNames={FIELD_NAMES}
      multipleLinesTextData={titleTipsCfg}
      title={title}
      date={formatDateStr(dataTime, 'YYYY-MM')}
      icon={<img src={DollarIcon} />}
      value={getValueWithUnitText(value)}
      // @ts-ignore
      ratio={round(ratio)}
      metrics={metrics}
    />
  );
};

export default React.memo(ActualBudgetCompletionCard);
